import React from 'react';
import { BackButton, Header, HeaderAction, HeaderTitle } from './styles';

type RightAction = {
  label: string;
  onPress: () => void;
};

type Props = {
  title: string;
  onBack: () => void;
  rightAction?: RightAction;
};

export const MenuHeader = ({ title, onBack, rightAction }: Props) => {
  return (
    <Header>
      <BackButton type="button" onClick={onBack} aria-label="Back" />
      <HeaderTitle>{title}</HeaderTitle>
      {rightAction ? (
        <HeaderAction type="button" onClick={rightAction.onPress}>
          {rightAction.label}
        </HeaderAction>
      ) : null}
    </Header>
  );
};
